import { addAxiosResponseInterceptors } from '@didomi/helpers';
import { useAuthMethods, useAuthToken } from '@didomi/utility-react';
import axios, { AxiosInstance } from 'axios';
import { ApiError, reportSpaError } from '@utils';

export const axiosWithLogoutInstance = axios.create();
let axiosWithLogoutInterceptors: AxiosInstance;

export const useAxiosWithLogOut = () => {
  const token = useAuthToken();
  const { logout } = useAuthMethods();

  // Alter defaults after instance has been created
  axiosWithLogoutInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;

  // Global error handler - report API errors to the Error Hub
  axiosWithLogoutInstance.interceptors.response.use(
    response => response,
    error => {
      reportSpaError(new ApiError(error));
      throw error;
    },
  );

  if (axiosWithLogoutInterceptors) {
    return axiosWithLogoutInterceptors;
  }

  axiosWithLogoutInterceptors = addAxiosResponseInterceptors(axiosWithLogoutInstance, {
    onExpiredToken: logout,
    onForbidden: logout,
  });
  return axiosWithLogoutInterceptors;
};
